import React, { useState } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

/* ----------  styled-components  ---------- */

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: calc(100vh - 60px);
  background-color: #f0f0f0;
  padding: 20px;
  box-sizing: border-box;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 16px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 400px;
  box-sizing: border-box;
`;

const Button = styled.button`
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  border: none;

  &:hover {
    background-color: #0056b3;
  }
`;

/* ----------  UI for links  ---------- */

const ResponseContainer = styled.div`
  margin-top: 24px;
  padding: 20px 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 500px;
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LinkItem = styled.li`
  a {
    color: #007bff;
    text-decoration: underline;
    word-break: break-all;
    &:hover {
      text-decoration: none;
    }
  }
`;

/* ----------  Component  ---------- */

const PolizaInput: React.FC = () => {
  const [searchParams] = useSearchParams();
  const aseguradora = searchParams.get('aseguradora');
  const [polizaId, setPolizaId] = useState('');
  const [links, setLinks] = useState<string[]>([]);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const handleSubmit = async () => {
    setErrorMsg(null);
    setLinks([]);

    try {
      const res = await axios.post(
        'https://www.gruporomeroseguros.com/impresion',
        { aseguradora, polizaId },
        { responseType: 'text' } // ensures we get raw XML/text
      );

const urlRegex = /https?:\/\/[^\s"'<>]+/g;
const allUrls: string[] = res.data.match(urlRegex) || [];

const excluded = [
  'http://www.w3.org/2003/05/soap-envelope',
  'http://www.w3.org/2001/XMLSchema-instance',
  'http://www.w3.org/2001/XMLSchema',
  'http://tempuri.org/',
];

const filteredLinks = allUrls.filter((url) => !excluded.includes(url));


      if (filteredLinks.length === 0) {
        setErrorMsg('No se encontraron enlaces útiles en la respuesta.');
      } else {
        setLinks(filteredLinks);
      }
    } catch (err) {
      setErrorMsg('Error al consultar la póliza. Intente de nuevo.');
    }
  };

  return (
    <>
      <Header title={`Póliza - ${aseguradora || ''}`} />
      <Wrapper>
        <Title>Ingrese el número de póliza</Title>
        <Input
          type="text"
          value={polizaId}
          onChange={(e) => setPolizaId(e.target.value)}
          placeholder="Número de póliza"
        />
        <Button onClick={handleSubmit}>Consultar</Button>

        {(links.length > 0 || errorMsg) && (
          <ResponseContainer>
            {errorMsg ? (
              <span>{errorMsg}</span>
            ) : (
              <LinkList>
                {links.map((link) => (
                  <LinkItem key={link}>
                    <a href={link} target="_blank" rel="noopener noreferrer">
                      {link}
                    </a>
                  </LinkItem>
                ))}
              </LinkList>
            )}
          </ResponseContainer>
        )}
      </Wrapper>
    </>
  );
};

export default PolizaInput;
